import { render, staticRenderFns } from "./ViewAllFarm.vue?vue&type=template&id=0347c27c&scoped=true"
import script from "./ViewAllFarm.vue?vue&type=script&lang=js"
export * from "./ViewAllFarm.vue?vue&type=script&lang=js"
import style0 from "./ViewAllFarm.vue?vue&type=style&index=0&id=0347c27c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0347c27c",
  null
  
)

export default component.exports